var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text || !!_vm.$slots.default)?_c('p',{staticClass:"field__notes"},[(!_vm.$slots.default)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }